import { API_URL_ACCREDITATION_WISH as url } from 'constants/api'
import { redirect } from 'react-router-dom'
import type QueryClient from 'services/query'
import { mapAccreditationPayload } from 'services/trainingWish'
import { buildURL } from 'services/url'

interface Params {
  id: string
  lang: string
}

export const createAccreditation =
  (client: QueryClient) =>
  async ({ params, request }: { params: Params; request: Request }) => {
    const { id, lang } = params

    const reqUrl = new URL(request.url)
    const queryParams = new URLSearchParams(reqUrl.search)

    const formData = await request.formData()
    const safetyStandalone = formData.get('safetyStandalone') === 'true'
    const canViewAccreditationBoard = formData.get('canViewAccreditationBoard') === 'true'
    formData.delete('safetyStandalone')
    formData.delete('canViewAccreditationBoard')

    const payload = mapAccreditationPayload({ formData, accreditationId: Number(id) })

    try {
      await client.post(buildURL(url, queryParams), payload)
    } catch (e: any) {
      return { error: e.response }
    }

    // @TODO Default vintage
    const standaloneRedirect = canViewAccreditationBoard ? 'accreditations?user.enabled=true' : 'catalog/accreditation'
    return redirect(queryParams.get('from') ?? `/${lang}/${safetyStandalone ? standaloneRedirect : 'needs-summary'}`)
  }
